import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import Avatar from "@material-ui/core/Avatar";
import profileimage from "src/Assets/images/profileimage.png";
import styles from "src/Assets/css/home/post.module.css";
import locationpinchildpost from "src/Assets/images/locationpinchildpost.png";
import * as feedactions from "../../store/actions/feedactions/feedActionCreator";
import { useSelector, useDispatch } from "react-redux";
import * as childSayActions from "../../store/actions/searchactions/childsayActionCreator";
import LocationTag from "../Reusuablecomponents/LocationTag";
import * as SignInActions from "../../store/actions/SignInActions/SignInAction";
import API from "../../network";
import RestrictionMsgModal from "src/Components/RestrictionMsgModal";
import AvatarBadge from "src/Components/AvatarBadge";
import EditLocation from "../../Utils/editLocation";
import EditCalendarComponent from "../Reusuablecomponents/EditCalendar";
import TruncatedTextWithTooltip from "../../Utils/truncatedTextWithTooltip";
import closeIcon from "src/Assets/images/CloseButton.svg";
import attachIcon from "src/Assets/images/attachIcon.png";
import attachIconAfterUpload from "src/Assets/images/attachIconAfterUpload.png";
import Tooltip from "@mui/material/Tooltip";
import {
  capitalizeFirstLetter,
  ignoreSpacesAndUrlsFromMsg,
} from "src/Utils/commonUtils";
import AttachmentUploader from "src/Utils/AttachmentUploader";

const PostMessageValidation = (props) => {
  const {
    increaseSayCount,
    updateSayCount,
    fetchContributors,
    latitude,
    longitude,
    locationAddress,
    updateNewSelectedLocation,
    removeNewSelectedLocationKey,
    flow,
    postData, // this prop is post's object for notification and advance search
    shouldUseModeratorStatus,
    isPm,
    postType,
    activityOrPrivateTagPostdata,
    keywordName,
    docName,
    onDeleteAttachment,
    isAttacmentDeleted,
    setIsAttacmentDeleted,
    onActionSuccess
  } = props;
  const [isInputData, setInputData] = React.useState(false);
  const dispatch = useDispatch();
  const [isButtonEnable, setButtonEnable] = React.useState(false);
  const [setLocationSelect, isLocationSelect] = React.useState("");
  const [isLat, setLat] = React.useState("");
  const [isLng, setLng] = React.useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [tagRestModalMsg, setTagRestModalMsg] = useState("");
  const [charCount, setCharCount] = useState(0);
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const [reminderDateAndTime, setReminderDateAndTime] = useState(null);
  const [attachment, setAttachment] = useState(null);
  const [inputAreaText, setInputAreaText] = useState("");

  const [location, setLocation] = useState({
    selectedAddress: locationAddress || "",
    latitude: latitude || "",
    longitude: longitude || "",
  });
  const initialLocationRef = useRef(
    props?.post?.locName !== undefined && props?.post?.locName !== null
      ? props.post.locName
      : locationAddress || ""
  );
  const isReadOnly = props.readOnly || props.isActionDisabled || false;
  const isUserLoggedIn = useSelector(
    (state) => state.SignInReducer.isAuthorized
  );

  console.log(`activityOrPrivateTagPostdata:`, activityOrPrivateTagPostdata);

  const signInStatus = Cookies.get("signInStatus");
  const inputRef = useRef(null);

  const isAskType = () => {
    return (
      keywordName === "OpenASK" ||
      keywordName === "Open ASK" ||
      keywordName === "TrendingASK" ||
      keywordName === "ASK" ||
      activityOrPrivateTagPostdata?.Keyword_ID === "actASK" ||
      activityOrPrivateTagPostdata?.message_type === "A"
    );
  };

  const placeholderName = () => {
    return isAskType() ? "Post your Answer" : "Post your Reply";
  };

  const buttonColor = isAskType() ? "#2168b2" : "#efba29";

  const handleInput = (e) => {
    if (inputRef.current) {
      inputRef.current.style.height = "auto";
      inputRef.current.style.height = `${e.target.scrollHeight - 16}px`;
    }
  };

  useEffect(() => {
    const msg = (props?.Message || "").trimEnd();
    const { msgLength } = ignoreSpacesAndUrlsFromMsg(msg);
    setCharCount(msgLength);
  }, [props.Message]);

  const handleLocationUpdate = (address, lat, lng) => {
    setLocation({
      selectedAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const handleLocationDelete = () => {
    setLocation({
      selectedAddress: "",
      latitude: "",
      longitude: "",
    });
    props?.updateNewSelectedLocation && props?.updateNewSelectedLocation("");
  };

  console.log(`postData for search and parent Notification post:`, postData);

  // var newLine = "\r\n\r\n"
  // // var mybr = document.createElement('br');
  // var data1 = [];
  // var data2 = [];
  var TotalLetters = 280;
  // var j = 0;
  // var strArray = [];
  var inputDataLen;

  const ignoreSpaceandUrls = (mstrData, txtId) => {
    let inputData = mstrData;

    if (inputData.length !== 0) {
      setInputData(true);
    } else {
      setInputData(false);
    }
    inputDataLen = inputData.length;
    setCharCount(inputData.length);
    // var commas;
    // var dsr = navigator.userAgent.split("MSIE");
    let inputText = document.getElementById(txtId).value;
    inputText = inputText.replace(/\n/g, " ");
    let strArray = inputText.split(" ");
    let validlettercount = 0;
    let i;
    for (i = 0; i < strArray.length; i++) {
      if (
        strArray[i].indexOf("http://") == -1 &&
        strArray[i].indexOf("www.") == -1 &&
        strArray[i].indexOf("https://") == -1 &&
        strArray[i].indexOf("HTTP://") == -1 &&
        strArray[i].indexOf("WWW.") == -1 &&
        strArray[i].indexOf("HTTPS://") == -1
      ) {
        validlettercount = validlettercount + strArray[i].length;
      } else if (
        strArray[i].indexOf("http://") &&
        strArray[i].indexOf("www.") &&
        strArray[i].indexOf("https://") &&
        strArray[i].indexOf("HTTP://") &&
        strArray[i].indexOf("WWW.") &&
        strArray[i].indexOf("HTTPS://")
      ) {
        validlettercount = validlettercount + strArray[i].length;
      }
    }
    inputDataLen = validlettercount;
  };

  // Function to format date as "07-Mar-2025 16:47"
  const formatUpdateReminderTime = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  // Function to format date as "07-Mar-2025 4:47 PM"
  const formatJsReminderTime = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12; // Convert 24-hour to 12-hour format
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const amPm = date.getHours() >= 12 ? "PM" : "AM";

    return `${day}-${month}-${year} ${hours}:${minutes} ${amPm}`;
  };

  const myFunction = (id, value = "") => {
    setErrorMessage("");
    let inputValue;
    let saveEditChildSay;

    let letterCounter;
    // let sayButton = `buttonforchildsay${id}`;
    let saveButton;
    // console.log(props.messageType);
    if (props.messageType === "feedTextArea") {
      inputValue = `textInput${id}`;
      letterCounter = `letterCounterEdit${id}`;
      saveButton = `buttonforEdit${id}`;
      // saveEditChildSay = document.getElementById(saveButton);
    } else if (props.messageType === "sendaMail") {
      inputValue = `textInputMail${id}`;
      letterCounter = `letterCounterMail${id}`;
      saveButton = `buttonforEdit${id}`;
    } else if (props.messageType === "editBio") {
      inputValue = `bioInput${id}`;
      letterCounter = `letterCounterBio${id}`;
      saveButton = `buttonforBioSave${id}`;
    } else {
      inputValue = `textInputPost${id}`;
      letterCounter = `letterCounterSay${id}`;
      saveButton = `buttonforchildsay${id}`;
      // saveEditChildSay = document.getElementById(saveButton);
    }
    saveEditChildSay = document.getElementById(saveButton);
    // var say_ButtonId=document.getElementById(sayButton)

    let letters = value || document.getElementById(inputValue).value;
    const formattedValue = capitalizeFirstLetter(letters);
    document.getElementById(inputValue).value = formattedValue;
    // ignoreSpaceandUrls(letters, inputValue);
    const { msgLength, hasMessage } = ignoreSpacesAndUrlsFromMsg(letters);
    setInputData(hasMessage);
    setCharCount(msgLength);
    // if (document.getElementById(letterCounter) !== null) {
    //   var label_count = document.getElementById(letterCounter);
    //   label_count.innerText = TotalLetters - inputDataLen;
    // }
    const chCount = msgLength;

    if (document.getElementById(letterCounter) !== null) {
      document.getElementById(letterCounter).style.color =
        chCount > TotalLetters ? "red" : "black";
    }

    if (chCount > TotalLetters || chCount === 0) {
      if (saveEditChildSay !== null) {
        saveEditChildSay.style.disabled = true;
        saveEditChildSay.style.backgroundColor = "lightgray";
      }
      setButtonEnable(false);
    } else {
      if (saveEditChildSay !== null) {
        const msgType = props.messageType;
        saveEditChildSay.style.disabled = false;
        saveEditChildSay.style.backgroundColor =
          msgType === "feedTextArea" ||
          msgType === "sendaMail" ||
          msgType === "editBio"
            ? "#2181ce"
            : "#36B549";
      }
      setButtonEnable(true);
    }
  };

  const submit = async (id) => {
    try {
      let inputValue = `textInputPost${id}`;
      let lettersCount = document.getElementById(inputValue).value?.trimEnd() || "";
      let letterCounter = `letterCounterSay${id}`;
      // const newListData = listData.map((item) => {
      //   if (item.id === id) {
      //     return { ...item, sayCount: item.sayCount + 1 };
      //   } else {
      //     return item;
      //   }
      // });
      // setListData(newListData);

      if (isButtonEnable && charCount > 0 && charCount <= TotalLetters) {
        let lnglat;
        if ((isLat !== "") & (isLng !== "")) {
          lnglat = isLat + "," + isLng;
        } else {
          lnglat = "";
        }
        const response = await props.postChildSayData(
          id,
          lettersCount,
          lnglat,
          setLocationSelect,
          attachment
        );
        if (response === "New Hash") {
          setErrorMessage("You can't create a New hash tag");
          return;
        }
        setLat("");
        setLng("");
        isLocationSelect("");
        setAttachment(null);

        //TODO: fetchChildSaysData should be removed once subscriber is added
        //Subscriber should add new entry to existing childSays list
        // setTimeout(function () {
        //   // dispatch(childSayActions.fetchChildSayData(`?id=${id}`));
        //   props.fetchChildSaysData(id);
        // }, 500);
        if (response !== "E_Say" && response !== "E") {
          updateSayCount && updateSayCount(id);
        }
        // dispatch(childSayActions.fetchChildSayData(`?id=${id}&in_pop_columns=all&in_limit=0`))
        document.getElementById(inputValue).value = "";
        setTimeout(() => {
          fetchContributors && fetchContributors();
          dispatch(SignInActions.fetchloginUser());
        }, 1000);
        // document.getElementById(letterCounter).innerText = TotalLetters;
        setInputData("");
        setCharCount(0);
        setInputAreaText("");
        // console.log(setLocationSelect,isLat,isLng)
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onCancelSelection = (id) => {
    setErrorMessage("");
    removeNewSelectedLocationKey && removeNewSelectedLocationKey();
    let inputText;
    let letterCounter;
    let postMessage;
    let buttonforEdit;
    let buttonforCancel;
    if (props.messageType === "editBio") {
      inputText = `bioInput${id}`;
      letterCounter = `letterCounterBio${id}`;
      postMessage = `postBioMessage${id}`;
      buttonforEdit = `buttonforBioSave${id}`;
      buttonforCancel = `buttonforBioCancel${id}`;
    } else {
      inputText = `textInput${id}`;
      letterCounter = `letterCounterEdit${id}`;
      postMessage = `postMessage${id}`;
      buttonforEdit = `buttonforEdit${id}`;
      buttonforCancel = `buttonforCancel${id}`;
    }
    // let buttonforEdit = `buttonfor${id}`

    props?.onCloseEdit && props?.onCloseEdit();
    props?.setEditBio && props?.setEditBio(false);

    // if (document.getElementById(inputText).style.display === "none") {
    //   document.getElementById(inputText).style.display = "block";
    //   document.getElementById(buttonforEdit).style.display = "block";
    //   document.getElementById(buttonforCancel).style.display = "block";
    //   document.getElementById(letterCounter).style.display = "block";
    //   if (props.messageType === "feedTextArea") {
    //     document.getElementById(postMessage).style.display = "none";
    //   }
    // } else {
    //   document.getElementById(inputText).style.display = "none";
    //   document.getElementById(buttonforEdit).style.display = "none";
    //   document.getElementById(buttonforCancel).style.display = "none";
    //   document.getElementById(letterCounter).style.display = "none";
    //   if (props.messageType === "feedTextArea") {
    //     document.getElementById(postMessage).style.display = "block";
    //   }
    // }
  };

  const onSendaMail = async (id) => {
    let inputValue = `textInputMail${id}`;
    let letterCounter = `letterCounterMail${id}`;
    let lettersCount = document.getElementById(inputValue).value;
    // dispatch(
    //   feedactions.postaMailData(
    //     `?mid=${id}&comment=${lettersCount}&checkHsh=message`
    //   )
    // );
    if (lettersCount.length > 280) return;
     const response = await API.postMail(id, lettersCount);
    document.getElementById(inputValue).value = "";
    document.getElementById(letterCounter).innerText = TotalLetters;
    props.onClose();
    if (response?.data?.justFollowed) {
      onActionSuccess?.(() => {});
    }
  };

  const getWordWithHash = (sentence) => {
    const regex = /(?:^|\s)(#\w+)\b/g;

    // Find all matches in the sentence
    const matches = sentence.match(regex);

    // Return the array of matched words (or an empty array if no matches)
    return matches ? matches.map((match) => match.trim()) : [];
  };

  const updateActivityAsksTags = async (id) => {
    let inputValue = `textInput${id}`;
    let lettersCount = document.getElementById(inputValue).value?.trimEnd() || "";
    const isAttachmentUpdated = isAttacmentDeleted === "success" ? true : false;

    const isTextUnchanged = (props?.Message || "").trimEnd() === lettersCount;
    const isLocationUnchanged =
      (initialLocationRef.current || "") === (location?.selectedAddress || "");

    if (
      isTextUnchanged &&
      isLocationUnchanged &&
      !attachment &&
      !isAttachmentUpdated
    ) {
      setErrorMessage("At least one modification required");
      return;
    }
    if (lettersCount.length > 280) {
      return;
    }

    if (attachment) {
      const attachmentFormData = new FormData();
      attachmentFormData.append("file", attachment);
      attachmentFormData.append("messageID", id);

      const response = await API.updateAttachment(attachmentFormData);
    }

    //checking whether post is TAG or not
    if ((props?.filtertype || props?.filterType) === "activityTag") {
      const previousHashArr = getWordWithHash(props?.Message || "");
      const previousHash =
        Array.isArray(previousHashArr) && previousHashArr.length > 0
          ? previousHashArr[0]
          : "";

      const currentHashArr = getWordWithHash(lettersCount || "");
      const currentHash =
        Array.isArray(currentHashArr) && currentHashArr.length > 0
          ? currentHashArr[0]
          : "";

      if (previousHash !== currentHash) {
        setErrorMessage("You can't create a New hash tag");
        return;
      }
    }

    try {
      let refresh = false;
      const { locName, msgLat, msgLng } = props?.post || {};
      const messageId = props?.post?.id ?? props?.post?.message_id;
      const locationName = location?.selectedAddress || "";
      const userLoc = "";
      const msgLoc =
        locationName && location?.latitude && location?.longitude
          ? `${location.latitude},${location.longitude}`
          : "";
      let formData = new FormData();
      formData.append("messageID", messageId);
      formData.append("message", lettersCount);
      formData.append("msgLoc", msgLoc);
      formData.append("locName", locationName);
      formData.append("userLoc", userLoc);
      const resp = await API.updateProfilePostLocation(formData);
      const status = resp?.data?.status || "";
      refresh = checkForHash(status);
      if (refresh) {
        props?.onMessagedUpdated &&
          props?.onMessagedUpdated(
            id,
            lettersCount,
            locationName,
            attachment,
            location?.latitude,
            location?.longitude
          );
        window.dispatchEvent(
          new CustomEvent("postUpdated", {
            detail: {
              id,
              message: lettersCount,
              locationName,
              attachment,
              lat: location?.latitude,
              lng: location?.longitude,
            },
          })
        );
        props?.onCloseEdit && props?.onCloseEdit();
      }
      setIsAttacmentDeleted?.(null);
    } catch (e) {
      console.log(e);
    }
  };

  const onEditPost = async (id) => {
    const currentFilterType = props?.filtertype || props?.filterType;
    if (
      currentFilterType === "activityTag" ||
      currentFilterType === "activityAsk" ||
      currentFilterType === "activityUpdate" ||
      currentFilterType === "activitySay" ||
      currentFilterType === "activityAnswer" ||
      currentFilterType === "activityReply" ||
      currentFilterType === "AnswerNotification" ||
      currentFilterType === "ReplyNotification"
    ) {
      updateActivityAsksTags(id);
      return;
    }

    let refresh = true;
    let inputValue = `textInput${id}`;
    let letterCounter = `letterCounterEdit${id}`;
    let lettersCount = document.getElementById(inputValue).value?.trimEnd() || "";
    const originalReminder = props?.post?.js_reminder_time?.trim();

    if (attachment) {
      const attachmentFormData = new FormData();
      attachmentFormData.append("file", attachment);
      attachmentFormData.append("messageID", id);

      const response = await API.updateAttachment(attachmentFormData);
    }

    const isReminderTimeEqual =
      props?.post?.Keyword_ID === "impupdate"
        ? reminderDateAndTime === null
          ? true // Always treat as unchanged when user hasn't picked a new reminder
          : formatJsReminderTime(reminderDateAndTime) === originalReminder
        : true; // Skip check if not "impupdate"
    const isAttachmentUpdated = isAttacmentDeleted === "success" ? true : false;
    const isTextUnchanged = (props?.Message || "").trimEnd() === lettersCount;
    const isLocationUnchanged =
      (initialLocationRef.current || "") === (location?.selectedAddress || "");

    if (
      isTextUnchanged &&
      isLocationUnchanged &&
      isReminderTimeEqual &&
      !attachment &&
      !isAttachmentUpdated
    ) {
      setErrorMessage("At least one modification required");
      return;
    }
    if (lettersCount.length > 280) {
      return;
    }

    const formdata = new FormData();
    if (location?.latitude && location?.longitude) {
      const lat = `${location.latitude},${location.longitude}`;
      formdata.append("msgLoc", lat);
    }
    if (location?.selectedAddress) {
      formdata.append("locName", location.selectedAddress);
    }

    formdata.append("userLoc", "");

    //checking whether post is TAG or not
    let isTag = false;
    const { message_type, Keyword_ID } = props?.post || {};
    if (
      props?.filtertype === "hashtag" ||
      message_type === "H" ||
      message_type === "X" ||
      Keyword_ID === "hashTAG"
    ) {
      isTag = true;
      const previousHashArr = getWordWithHash(props?.Message || "");
      const previousHash =
        Array.isArray(previousHashArr) && previousHashArr.length > 0
          ? previousHashArr[0]
          : "";

      const currentHashArr = getWordWithHash(lettersCount || "");
      const currentHash =
        Array.isArray(currentHashArr) && currentHashArr.length > 0
          ? currentHashArr[0]
          : "";

      if (previousHash !== currentHash) {
        setErrorMessage("You can't create a New hash tag");
        return;
      }
    }

    try {
      if (isTag) {
        const { id: messageId, locName, msgLat, msgLng } = props?.post || {};
        let locationName;
        let msgLoc;
        let userLoc = "";
        if (location?.latitude && location?.longitude) {
          const lat = `${location.latitude},${location.longitude}`;
          msgLoc = lat;
        }
        if (location?.selectedAddress) {
          locationName = location.selectedAddress;
        }
        let formData = new FormData();
        formData.append("messageID", messageId);
        formData.append("message", lettersCount);
        const resp = await API.editPrivateTag(
          formData,
          userLoc,
          msgLoc,
          locationName
        );
        const status = resp?.data?.status || "";
        refresh = checkForHash(status);
      } else if (
        props.filtertype === "update" ||
        props?.post?.Keyword_ID === "impupdate"
      ) {
        formdata.append("announceID", id);
        formdata.append("message", lettersCount);
        if (reminderDateAndTime) {
          if (props?.post?.reminder_id !== null) {
            formdata.append("updateReminderId", props?.post?.reminder_id);
          }
          formdata.append(
            "updateReminderTime",
            formatUpdateReminderTime(reminderDateAndTime)
          );
          formdata.append(
            "jsReminderTime",
            formatJsReminderTime(reminderDateAndTime)
          );
        }
        // await API.editUpdate(id, lettersCount);
        const res = await API.editUpdateLocation(formdata);
        if (res?.data?.status === "New Hash") {
          setErrorMessage("You can't create a New hash tag");
          return;
        }
      } else {
        formdata.append("messageID", id);
        formdata.append("message", lettersCount);
        const res = await API.editPostLocation(formdata);
        // await API.editPost(formdata);
        if (res?.data?.status === "New Hash") {
          setErrorMessage("You can't create a New hash tag");
          return;
        }
      }
      //TODO: Once subscriber logic is added, remove this api call
      //subscriber should modify this edited record in existing list of feed
      if (refresh) {
        if (props?.feedType === "allFeed") {
          props.updateFeedListPostMessage &&
            props.updateFeedListPostMessage(
              id,
              lettersCount,
              location?.selectedAddress,
              attachment
            );
        } else {
          props.refreshFeedData &&
            props.refreshFeedData(
              props.parentId ? true : false,
              props.parentId
            );
        }
        window.dispatchEvent(
          new CustomEvent("postUpdated", {
            detail: {
              id,
              message: lettersCount,
              locationName: location?.selectedAddress,
              attachment,
            },
          })
        );
      }
      // props.fetchFeedData(props.filtertype);
      setIsAttacmentDeleted?.(null);
    } catch (e) {
      console.log(e);
    }

    // if (props.filtertype === "&&filtertype=update") {
    //   dispatch(
    //     feedactions.editaUpdate(
    //       `?announceID=${id}&message=${lettersCount}&ident=actUpdate&argval=share&timeZone=IST`
    //     )
    //   );
    // } else {
    //   dispatch(
    //     feedactions.editaPost(`?messageID=${id}&message=${lettersCount}`)
    //   );
    // }

    // dispatch(feedactions.fetchFeedData(`?startlimit=0${props.filtertype}`));
    // document.getElementById(inputValue).value = "";
    // document.getElementById(letterCounter).innerText = TotalLetters;
  };

  const checkForHash = (status) => {
    if (String(status).toLowerCase() === "new hash") {
      setErrorMessage("You can't create a New hash tag");
      return false;
    } else if (String(status).includes("#")) {
      setErrorMessage("You can't create a New hash tag");
      return false;
    }
    return true;
  };

  const placeholderValue = placeholderName();

  const onBioUpdate = async (id) => {
    let editBioInputValue = `bioInput${id}`;
    let editBioLetterCounter = `letterCounterBio${id}`;
    let editBioLetterCount = document.getElementById(editBioInputValue).value;
    // dispatch(feedactions.fetchEditBio(`shortBio=${editBioLetterCount}`));

    if (props?.Message === editBioLetterCount) {
      setErrorMessage("At least one modification required");
      return;
    }

    await API.editBio(editBioLetterCount);
    dispatch(SignInActions.fetchloginUser());

    document.getElementById(editBioInputValue).value = "";
    document.getElementById(editBioLetterCounter).innerText = TotalLetters;

    props?.setEditBio && props?.setEditBio(false);
  };
  const isPmDefined = isPm == 0 || isPm == 1;
  const hasViewActivityInfo =
    Object.keys(userDetails?.userData?.viewActivityUserTenantInfo || {})
      .length > 0;

  const isPrimaryModerator = shouldUseModeratorStatus
    ? postData?.isPM == 1 && postData?.isModerator == 1
    : isPmDefined
    ? isPm == 1
    : postType === "askOrTagActivity" || postType === "Answer"
    ? activityOrPrivateTagPostdata?.isPM == 1 &&
      activityOrPrivateTagPostdata?.isModerator == 1
    : hasViewActivityInfo
    ? userDetails?.userData?.viewActivityUserTenantInfo?.isPM == 1 &&
      userDetails?.userData?.viewActivityUserTenantInfo?.isModerator == 1
    : userDetails?.userData?.isCurrentCommunityPm == 1;

  const isModerator = shouldUseModeratorStatus
    ? postData?.isPM == 0 && postData?.isModerator == 1
    : isPmDefined
    ? isPm == 0
    : postType === "askOrTagActivity" || postType === "Answer"
    ? activityOrPrivateTagPostdata?.isPM == 0 &&
      activityOrPrivateTagPostdata?.isModerator == 1
    : hasViewActivityInfo
    ? userDetails?.userData?.viewActivityUserTenantInfo?.isPM == 0 &&
      userDetails?.userData?.viewActivityUserTenantInfo?.isModerator == 1
    : userDetails?.userData?.moderatorStatus == 1 &&
      userDetails?.userData?.isCurrentCommunityPm == 0;

  return (
    <div key={props.id}>
      {/* <textarea rows="2" cols="50" id={`textInput${props.id}`} onKeyUp={() => myFunction(props.id)}></textarea> */}
      <div className={styles.sendaMailModel} style={{ width: "103%" }}>
        {props.messageType === "feedTextArea" ? (
          <>
            <div
              className={styles.textareaContainer}
              style={{ marginTop: "6px", fontSize: "14px" }}
            >
              <textarea
                rows="2"
                cols="50"
                id={`textInput${props.id}`}
                onInput={() => myFunction(props.id)}
                onFocus={() => myFunction(props.id)}
                defaultValue={props.Message}
                className={styles.EditPostMessage}
                style={{ padding: "10px 10px 10px 10px" }}
              ></textarea>
            </div>
            <p
              dangerouslySetInnerHTML={{ __html: props.Message }}
              className={styles.postMessage}
              id={`postMessage${props.id}`}
            ></p>
          </>
        ) : props.messageType === "sendaMail" ? (
          <textarea
            rows="4"
            cols="50"
            className={styles.sendamailtextarea}
            id={`textInputMail${props.id}`}
            onInput={() => myFunction(props.id)}
            onFocus={() => myFunction(props.id)}
            placeholder={`What would you like to say to ${props.displayName}`}
          ></textarea>
        ) : props.messageType === "editBio" ? (
          <>
            <textarea
              rows="2"
              className={`${styles.editBioTextArea} ${
                props.isEditBio ? styles.editBioInfo : styles.editBioInfoNone
              }`}
              cols="20"
              id={`bioInput${props.id}`}
              onInput={() => myFunction(props.id)}
              onFocus={() => myFunction(props.id)}
              defaultValue={props.Message}
            ></textarea>
            {/* <p id={`postBioMessage${props.id}`} className={styles.postMessage} onClick={() => onBioSelection(props.id)}>
                                        {props.Message}
                                    </p> */}
          </>
        ) : (
          <>
            {signInStatus === "true" ? (
              <>
                <div>
                  <AvatarBadge
                    src={props.userImageSrc}
                    variant="square"
                    isPrimaryModerator={isPrimaryModerator}
                    isModerator={isModerator}
                  />
                </div>
                <div
                  style={{
                    minWidth: postType === "askOrTagActivity" ? "84%" : "88%",
                    position: "relative",
                  }}
                >
                  {/* <input
                    className={styles.commentinput}
                    placeholder="Say something..."
                    type="text"
                    id={`textInputPost${props.id}`}
                    onInput={() => myFunction(props.id)}
                  /> */}
                  <textarea
                    ref={inputRef}
                    className={
                      inputAreaText
                        ? styles.EditPostMessage
                        : styles.commentinput
                    }
                    placeholder={placeholderValue}
                    id={`textInputPost${props.id}`}
                    value={inputAreaText}
                    onInput={(e) => {
                      const value = e.target.value;
                      setInputAreaText(value);
                      myFunction(props.id, value);
                      handleInput(e);
                    }}
                    readOnly={isReadOnly}
                    style={{
                      cursor: isReadOnly ? "not-allowed" : "text",
                      paddingRight: "10px",
                      marginLeft: "10px",
                      // width: "95%"
                    }}
                  />
                </div>
              </>
            ) : null}
          </>
        )}
      </div>
      {errorMessage && (
        <div style={{ fontSize: 12, color: "red" }}>{errorMessage}</div>
      )}
      <div
        className={styles.postbuttonandlabel}
        style={{ minWidth: props?.minWidth }}
      >
        {props.messageType === "feedTextArea" ? (
          <div
            className={styles.postAttachmentIconsAndActionBtnMainTopContainer}
          >
            <div className={styles.postAttachmentIconsAndActionBtnContainer}>
              <div className={styles.postAttachmentIconsContainer}>
                <div className={styles.postLocationAttachmentTextContainer}>
                  <EditLocation
                    postLattitude={props.latitude}
                    postLongitude={props.longitude}
                    onLocationChange={handleLocationUpdate}
                    updateNewSelectedLocation={updateNewSelectedLocation}
                  />
                  {location.selectedAddress && (
                    <div className={styles.childfileLocationItem}>
                      <span className={styles.childfileLocationName}>
                        {location.selectedAddress}
                      </span>
                      <button
                        type="button"
                        onClick={handleLocationDelete}
                        className={styles.removeBtn}
                      >
                        <img
                          src={closeIcon}
                          alt="closeIcon"
                          className={styles.deleteIcon}
                        />
                      </button>
                    </div>
                  )}
                </div>
                <AttachmentUploader
                  onFileSelect={setAttachment}
                  allowMultiple={false}
                  docName={docName}
                  docLocation={props?.post?.docLocation || props?.docLocation}
                  onDeleteAttachment={onDeleteAttachment}
                  editPostId={props.id}
                />
                {props?.post?.Keyword_ID === "impupdate" ||
                props?.post?.Keyword_ID === "activityUpdate" ? (
                  <EditCalendarComponent
                    setReminderDateAndTime={setReminderDateAndTime}
                    previousReminder={props?.post?.js_reminder_time}
                  />
                ) : null}
              </div>
              {!location.selectedAddress && !docName && !attachment && (
                <div className={styles.saveCancelBtnContainer}>
                  <button
                    className={styles.editPost}
                    id={`buttonforEdit${props.id}`}
                    onClick={() => onEditPost(props.id)}
                  >
                    Save
                  </button>
                  <button
                    onClick={() => onCancelSelection(props.id)}
                    id={`buttonforCancel${props.id}`}
                    className={styles.editCancelPost}
                  >
                    Cancel
                  </button>
                </div>
              )}
              <label
                id={`letterCounterEdit${props.id}`}
                style={{
                  width:
                    location.selectedAddress || docName || attachment
                      ? "40%"
                      : "auto",
                  textAlign: "end",
                  whiteSpace: "nowrap",
                  marginTop: "5px",
                }}
              >
                {charCount}
                <label style={{ color: "black" }}>/280</label>
              </label>
            </div>
            {(location.selectedAddress || docName || attachment) && (
              <div
                className={styles.saveCancelBtnContainer}
                style={{ margin: "auto" }}
              >
                <button
                  className={styles.editPost}
                  id={`buttonforEdit${props.id}`}
                  onClick={() => onEditPost(props.id)}
                >
                  Save
                </button>
                <button
                  onClick={() => onCancelSelection(props.id)}
                  id={`buttonforCancel${props.id}`}
                  className={styles.editCancelPost}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        ) : props.messageType === "sendaMail" ? (
          <>
            <button
              id={`buttonforEdit${props.id}`}
              className={styles.sendaMail}
              onClick={() => onSendaMail(props.id)}
              disabled={charCount <= 0}
            >
              Send
            </button>
            <label id={`letterCounterMail${props.id}`}>
              {charCount}
              <label style={{ color: "black" }}>/280</label>
            </label>
          </>
        ) : props.messageType === "editBio" ? (
          <>
            <div className={styles.saveCancelBtnContainer}>
              <button
                id={`buttonforBioSave${props.id}`}
                onClick={() => onBioUpdate(props.id)}
                className={`${styles.editbioSave} ${
                  props.isEditBio ? styles.editBioInfo : styles.editBioInfoNone
                }`}
              >
                Save
              </button>
              <a
                onClick={() => onCancelSelection(props.id)}
                id={`buttonforBioCancel${props.id}`}
                className={`${styles.editbioCancel} ${
                  props.isEditBio ? styles.editBioInfo : styles.editBioInfoNone
                }`}
              >
                Cancel
              </a>
            </div>
            <label
              id={`letterCounterBio${props.id}`}
              className={
                props.isEditBio ? styles.editBioInfo : styles.editBioInfoNone
              }
              style={{ margin: "0px 0px 0px 5px" }}
            >
              {charCount}
              <label style={{ color: "black" }}>/280</label>
            </label>
          </>
        ) : (
          <div className={styles.childAnsReplyPostBtnTopMainContainer}>
            <div className={styles.childAnsReplyPostBtnMainContainer}>
              {signInStatus === "true" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    pointerEvents: "auto", // allow clicks
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "nowrap",
                      flexShrink: 0,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        marginLeft: "20px",
                        marginTop: "-15px",
                      }}
                    >
                      <LocationTag
                        isLocationSelect={isLocationSelect}
                        setLat={setLat}
                        setLng={setLng}
                        id={props.id}
                        setIsHide={() => {}}
                        readOnly={isReadOnly}
                      />
                    </div>
                    {setLocationSelect && (
                      <div
                        className={styles.childfileLocationItem}
                        style={{ marginLeft: "-20px" }}
                      >
                        <span
                          className={styles.childfileLocationName}
                          style={{ maxWidth: "50px" }}
                        >
                          <TruncatedTextWithTooltip text={setLocationSelect} />
                        </span>
                        <button
                          type="button"
                          onClick={() => isLocationSelect("")}
                          className={styles.removeBtn}
                        >
                          <img
                            src={closeIcon}
                            alt="closeIcon"
                            className={styles.deleteIcon}
                          />
                        </button>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      marginLeft:
                        !setLocationSelect && !attachment ? "-20px" : "-10px",
                      marginTop: "5px",
                    }}
                  >
                    <AttachmentUploader
                      onFileSelect={setAttachment}
                      allowMultiple={false}
                      showPreview={attachment ? true : false}
                      readOnly={isReadOnly}
                    />
                  </div>
                </div>
              )}
              {signInStatus === "true" && isInputData ? (
                <>
                  {!setLocationSelect && !attachment && (
                    <div className={styles.childpostBtnContainer}>
                      <button
                        className={styles.childpost}
                        id={`buttonforAnsOrReply${props.id}`}
                        onClick={() => submit(props.id)}
                        disabled={charCount === 0 || charCount > TotalLetters}
                        style={{
                          cursor:
                            charCount === 0 || charCount > TotalLetters
                              ? "not-allowed"
                              : "pointer",
                          opacity:
                            charCount === 0 || charCount > TotalLetters ? 0.5 : 1,
                          backgroundColor: buttonColor,
                        }}
                      >
                        Post
                      </button>
                      <button
                        className={styles.childpostCancelBtn}
                        disabled={charCount === 0}
                        style={{
                          cursor: charCount === 0 ? "not-allowed" : "pointer",
                          opacity: charCount === 0 ? 0.5 : 1,
                        }}
                        onClick={() => {
                          setInputAreaText("");
                          setCharCount(0);
                          setInputData(false);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <span></span>
              )}
              {signInStatus === "true" && (
                <label
                  id={`letterCounterSay${props.id}`}
                  style={{
                    width: setLocationSelect || attachment ? "40%" : "auto",
                    textAlign: "end",
                    whiteSpace: "nowrap",
                    marginTop: "8px",
                  }}
                >
                  {charCount}
                  <span style={{ color: "black" }}>/280</span>
                </label>
              )}
            </div>
            {(setLocationSelect || attachment) && (
              <div
                className={styles.childpostBtnContainer}
                style={{ margin: "auto" }}
              >
                <button
                  className={styles.childpost}
                  id={`buttonforAnsOrReply${props.id}`}
                  onClick={() => submit(props.id)}
                  disabled={charCount === 0 || charCount > TotalLetters}
                  style={{
                    cursor:
                      charCount === 0 || charCount > TotalLetters
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      charCount === 0 || charCount > TotalLetters ? 0.5 : 1,
                    backgroundColor: buttonColor,
                  }}
                >
                  Post
                </button>
                <button
                  className={styles.childpostCancelBtn}
                  disabled={charCount === 0}
                  style={{
                    cursor: charCount === 0 ? "not-allowed" : "pointer",
                    opacity: charCount === 0 ? 0.5 : 1,
                  }}
                  onClick={() => {
                    setInputAreaText("");
                    setCharCount(0);
                    setInputData(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        )}
        {/* <label id={`letterCounter${props.id}`}>280</label> */}
      </div>
      {/* <button onClick={() => submit} id={`saybutton${props.id}`}>Say</button><br /> */}
      {/* <label id={`letterCounter${props.id}`}>280</label> */}
      {/* <p id={`content${props.id}`}></p><br /><br /> */}
      {!!tagRestModalMsg && (
        <RestrictionMsgModal
          open={!!tagRestModalMsg}
          onClose={() => setTagRestModalMsg("")}
          message={tagRestModalMsg}
        />
      )}
    </div>
  );
};

export default PostMessageValidation;
